import React from 'react'
import { Circle as CircleSvg } from 'react-native-svg'
import { getTheme } from '@hedgit/lib/theme/index'
const OFFSET_Y = 10

interface Props {
  pct: number;
  color: string;
}

const Line = ({ pct, color }: Props) => {
  const theme = getTheme()
  return (
    <CircleSvg
      cx={`${pct}%`}
      cy={OFFSET_Y}
      r={3}
      stroke={color}
      strokeWidth="3"
      fill={theme.colors.white}
    />
  )
}

export default Line
